module.exports = __webpack_public_path__ + "img/2_2_3__5.2f08088d.png";